import { ComboBox } from "@progress/kendo-react-dropdowns";

export const NumericFormatProperty = {
  propertyName: "NumericFormat",
  propertyDisplay: "Numeric Formatting",
  propertyType: "string",
  propertyCategory: "Style",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <ComboBox
        data={["n", "n2", "n4", "c", "p", "p2"]}
        name={this.propertyName}
        allowCustom={true}
        onChange={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName] || "n"}
      />
    );
  },
};
